import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterColumn'
})
export class FilterColumnPipe implements PipeTransform {

     transform(data: any[], id: number, colum: string) {
     return data.filter(row => row[colum] == id);
  }

}
